import { useMemo } from 'react'
import type { PromoCode } from '@sevenrooms/domain'
import { z, type ZodSchema } from '@sevenrooms/form'

export type PromoCodeFormSchema = ZodSchema<typeof usePromoCodeFormSchema>

export function usePromoCodeFormSchema() {
  return useMemo(() => z.custom<PromoCode>().optional(), [])
}
